import CartDeliveryInfo from './CartDeliveryInfo'

export default CartDeliveryInfo
